/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_View_ListingInputs */

const en_directory_submit_check_view_listing = /** @type {(inputs: Directory_Submit_Check_View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View listing`)
};

const zh_directory_submit_check_view_listing = /** @type {(inputs: Directory_Submit_Check_View_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看收录`)
};

/**
* | output |
* | --- |
* | "View listing" |
*
* @param {Directory_Submit_Check_View_ListingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_view_listing = /** @type {((inputs?: Directory_Submit_Check_View_ListingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_View_ListingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_view_listing(inputs)
	return zh_directory_submit_check_view_listing(inputs)
});
export { directory_submit_check_view_listing as "directory.submit.check.view_listing" }